<template>
<v-container class="top-news-wrap">
  <v-row justify="center">
    <v-col
    cols="11">
      <v-simple-table>
        <template v-slot:top>
          <v-toolbar flat color="white">
            <!--タイトル-->
            <v-toolbar-title>
              お知らせ
              <v-icon medium class="mb-1" color="grey darken-1">
                mdi-information
              </v-icon>
            </v-toolbar-title>
            <v-divider
              class="mx-4"
              inset
              vertical
            ></v-divider>
              <div>
                <router-link :to="{ path: '/News'}" append>
                <button>
                一覧へ
                </button>
                </router-link>
              </div>
          </v-toolbar>
        </template>
        <!--お知らせテーブルのヘッダー-->
        <template v-slot:default>
          <thead>
            <tr>
              <th class="text-left"></th>
              <th class="text-left">日付</th>
              <th class="text-left">内容</th>
            </tr>
          </thead>
          <!--お知らせテーブルの内容-->
          <tbody>
            <tr
            v-for="item in displayContents"
            :key="item.index"
            :v-if="item.hasButton"
            >
            <td>
          <v-card-actions v-if="item.hasButton">
            <v-btn
            class="top-news"
            v-for="(btn, i) in item.button"
            :key="i"
            :color="btn.color"
            :href="btn.href">
              {{ btn.text }}
            </v-btn>
          </v-card-actions>
            </td>
              <td>
                <!-- <router-link :to="{name:'News',params:{id:item.date}}" append> -->
                 <!-- <router-link :to="{name:'News'}" append> -->
                <router-link :to="{ path: 'News', hash:'#' + item.date}" append>
                 <!-- <router-link :to="{name:'News',hush:'#{id:item.date}'}" append> -->
                 <!-- <router-link :to="{name:'News', hush:'#news001'}" append> -->
                {{ item.date }}
                </router-link>
              </td>
              <td>
                <!-- <router-link :to="{ path: '/News'}" append> -->
                 <router-link v-if="!isExternal(item.href)" :to="{ path: 'News', hash:'#' + item.date}" append>
                {{ item.content }}
                </router-link>
                <a v-if="isExternal(item.href)" :href="item.href">{{ item.content }}</a>
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
      <!--新着情報下部のページ管理部分-->
      <div class="text-center pt-2">
        <v-pagination
        v-model="page"
        :length="changeLength()"
        :total-visible="5"
        @input="pageChange"
        circle
        color="blue darken-4"
        prev-icon="mdi-menu-left"
        next-icon="mdi-menu-right">
        </v-pagination>
      </div>
    </v-col>
  </v-row>
</v-container>
</template>

<style>
.top-news {
  color: #fff !important;
}
.top-news {
  height: 30px !important;
  padding: 0 !important;
  min-width: 45px !important;
}
.v-data-table td, .v-data-table th {
    padding: 0 5px!important;
}

.top-news-wrap {
  max-width: 1280px;
}
</style>

<script>
export default {
  data () {
    return {
      // ページネーションに色がつく数字
      page: 1,
      // 5つ分のお知らせを表示
      pageSize: 5,
      // 表示させる分のお知らせの配列
      displayContents: [],
      // お知らせ
      contents: [
        {
          hasButton: 'true',
          // ボタンの内容
          button: [
            {
              text: 'Top!',
              href: '/News#2022-10-21',
              color: 'red'
            }],
          date: '2022-10-21',
          content: 'JAXA ASTEROID DATA EXPLORER (JADE) の開発で、KonniesystemがAcknowledgmentsに掲載されました。'
        },
        {
          date: '2025-04-18',
          content: 'ゴールデンウィーク休業のお知らせ'
        },
        {
          date: '2025-04-03',
          content: 'UMIN設立35・30周年、おめでとうございます。'
        },
        {
          date: '2025-02-25',
          content: 'ホームページ運用保守のお知らせ',
          href: '/hp_maintenance/'
        },
        {
          date: '2024-12-04',
          content: '冬季休業のお知らせ'
        },
        {
          date: '2024-07-24',
          content: 'Joomla 5へのアップデートについて'
        },
        {
          date: '2024-07-23',
          content: '夏季休業のお知らせ'
        },
        {
          date: '2024-04-25',
          content: 'ゴールデンウィーク休業のお知らせ'
        },
        {
          date: '2023-12-15',
          content: '「岩﨑胃腸科・内科」様ホームページ作成、公開のご案内'
        },
        {
          date: '2023-12-12',
          content: '冬季休業のお知らせ'
        },
        {
          date: '2023-07-21',
          content: '夏季休業のお知らせ'
        },
        {
          date: '2023-04-21',
          content: 'ゴールデンウィーク休業のお知らせ'
        },
        {
          date: '2022-11-30',
          content: '冬季休業のお知らせ'
        },
        {
          date: '2022-11-17',
          content: '学会サポートページの実績　ホームページ紹介欄を更新いたしました。'
        },
        {
          date: '2022-09-15',
          content: '研究開発のページを更新いたしました。'
        },
        {
          date: '2022-08-02',
          content: '夏季休業のお知らせ'
        },
        {
          date: '2022-04-14',
          content: 'ゴールデンウィーク休業のお知らせ'
        },
        {
          date: '2021-11-24',
          content: '冬季休業のお知らせ'
        },
        {
          date: '2021-07-20',
          content: '夏季休業のお知らせ'
        },
        {
          date: '2021-04-27',
          content: 'ゴールデンウィーク休業のお知らせ'
        },
        {
          date: '2020-12-11',
          content: '冬季休業のお知らせ'
        },
        {
          date: '2020-07-29',
          content: '夏季休業のお知らせ'
        },
        {
          date: '2020-04-22',
          content: 'ゴールデンウィーク休業のお知らせ'
        },
        {
          date: '2019-11-21',
          content: '冬季休業のお知らせ'
        },
        {
          date: '2019-07-24',
          content: '夏季休業のお知らせ'
        },
        {
          date: '2019-04-07',
          content: 'ゴールデンウィーク休業のお知らせ'
        },
        {
          date: '2018-12-10',
          content: '冬期休業のお知らせ'
        },
        {
          date: '2018-08-03',
          content: '夏季休業のお知らせ'
        },
        {
          date: '2018-04-21',
          content: 'ゴールデンウィーク休業のお知らせ'
        },
        {
          date: '2017-12-15',
          content: '冬期休業のお知らせ'
        }
        // {
        //   date: '2017-10-10',
        //   content: '学会サポートの料金を更新しました。'
        // },
        // {
        //   date: '2017-10-05',
        //   content: '検索システムを更新しました。'
        // },
        // {
        //   date: '2017-09-29',
        //   content: 'e-Learningシステムを更新しました。'
        // },
        // {
        //   date: '2017-09-25',
        //   content: '学術集会向けオンライン演題登録/査読システムを更新しました。'
        // },
        // {
        //   date: '2017-09-25',
        //   content: 'OSS製品のサポートを更新しました。'
        // },
        // {
        //   date: '2017-09-20',
        //   content: 'サイトマップを更新しました。'
        // },
        // {
        //   date: '2017-09-19',
        //   content: '研究開発の実績を更新しました。'
        // },
        // {
        //   date: '2017-09-15',
        //   content: '受託開発の開発例を更新しました。'
        // }
      ]
    }
  },
  methods: {
    // 表示させる要素を変更
    pageChange: function (pageNumber) {
      this.displayContents = this.contents.slice(this.pageSize * (pageNumber - 1), this.pageSize * (pageNumber))
    },
    // 配列に要素が追加されたらページネーションの数を自動で増やす
    changeLength: function () {
      this.length = 3
      if (this.contents.length % 5 === 1) {
        this.length += 1
      }
      return this.length
    },
    isExternal: function (href) {
      if (href) {
        return true
      }
      return false
    }
  },
  // 5つ分の要素を表示
  mounted: function () {
    this.displayContents = this.contents.slice(0, this.pageSize)
  }
}
</script>
